import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { AbstractNgModelComponent } from '../abstract-ng-model/abstract-ng-model.component';
@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SelectComponent,
    },
  ],
})
export class SelectComponent
  extends AbstractNgModelComponent
  implements OnChanges
{
  @Input() label = '';
  @Input() formControl: FormControl = new FormControl<any | null>(
    null,
    Validators.required
  );
  override value: any;

  @Input() data = [{ label: '', value: '' }];

  ngOnChanges(changes: SimpleChanges): void {}
}
